import React, { Fragment } from 'react';
import styles from './index.module.scss';
import Tooltip from '@components-clean/core/tooltip';
import { stringDateWithoutTimeFromUtc } from '@utils/convertor';

export type SubjectProfileDetailsCardItem = {
    key: string;
    label: string;
    value: string;
};

export function formatStringOrNumber(str: string | number | null | undefined) {
    return str?.toString() ?? '';
}
export function formatDate(dateString: string | null | undefined) {
    if (dateString == null) {
        return '';
    }
    return stringDateWithoutTimeFromUtc(dateString, 'DD-MMM-yyyy') ?? '';
}

type Props = {
    items: SubjectProfileDetailsCardItem[];
};

const DetailsCardDetailList = ({ items }: Props) => {
    return (
        <div className={styles.cardDetailsListWrapper}>
            {items.map((item) => (
                <Fragment key={item.key}>
                    <label htmlFor={item.key} className={styles.cardDetailsListRowLabel}>
                        {item.label}
                    </label>

                    <div className={styles.cardDetailsListRowValueWrapper}>
                        <Tooltip position="bottom">
                            <div id={item.key} title={item.value} className={styles.cardDetailsListRowValue}>
                                {item.value}
                            </div>
                        </Tooltip>
                    </div>
                </Fragment>
            ))}
        </div>
    );
};

export default DetailsCardDetailList;
